import CryptoJS from 'crypto-js'

let kkUtil = {
  getClientType() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("micromessenger") > 0) {
      return "wechat";
    } else if (ua.indexOf("android") > 0) {
      return "android";
    } else if (ua.indexOf("iphone") > 0 || ua.indexOf("ipad") > 0) {
      return "ios";
    } else {
      return "pc";
    }
  },
  getQueryStr(paraName) {
    let query = window.location.search.substring(1);
    if (typeof (query) == "undefined" || query == null || query == "") {
      return false;
    }
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] == paraName) {
        return pair[1];
      }
    }
    return false;
  },
  isInWebView() {
    let ua = navigator.userAgent;
    return ua.match(/MyShell/i) == 'MyShell';
    // if (ua.match(/micromessenger/i) == 'micromessenger') { // 微信浏览器判断
    //   return false
    // } else if (ua.match(/qq/i) == 'qq') { // QQ浏览器判断
    //   return false
    // } else if (ua.match(/weibo/i) == "weibo") {
    //   return false
    // } else {
    //   if (ua.match(/android/i) != null) {
    //     return ua.match(/browser/i) == null
    //   } else if (ua.match(/iphone/i) != null) {
    //     return ua.match(/safari/i) == null
    //   } else {
    //     return (ua.match(/macintosh/i) == null && ua.match(/windows/i) == null)
    //   }
    // }
  },
  inWechatAndQQ() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/i) == 'micromessenger' || (ua.match(/qq/i) == 'qq' && ua.match(/qqbrowser/i) != 'qqbrowser')) { // 微信/qq浏览器判断
      return true;
    }
    return false;
  },
  /**
   * 当前是否是安卓浏览器
   */
  isInAndroidBrowser() {
    if (this.isInWebView()) {
      return false;
    } else {
      return this.getClientType() === 'android';
    }
  },
  /**
   * 当前是否是iOS浏览器
   */
  isInIosBrowser() {
    if (this.isInWebView()) {
      return false;
    } else {
      return this.getClientType() === 'ios';
    }
  },
  getDomainFromUrl(url) {
    if (!url || url == "") {
      return "unknow";
    } else {
      let str = url.split("/");
      if (str[2]) {
        return str[2];
      } else {
        return "unknow";
      }
    }
  },
  isEmpty(param) {
    if (param == "undefined" || param == null || param == "null" || param == "") {
      return true;
    }
    return false;
  },
  aesEncryptHex(str, key) {
    return CryptoJS.AES.encrypt(
      str,
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    ).ciphertext.toString();
  },
  e(str) {
    return CryptoJS.AES.encrypt(
      str,
      CryptoJS.enc.Utf8.parse('VjpuhCrDAt1MDGbP'),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    ).ciphertext.toString();
  },
  aesDecrypt(encrypted, key) {
    let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    decrypted = CryptoJS.enc.Utf8.stringify(decrypted);
    return decrypted;
  },
  md5(str) {
    return CryptoJS.MD5(str).toString().toLowerCase();
  },
  // getJsPath(bookId, chapterNum, imgPath, zoom) {
  //   if (imgPath == null) {
  //     throw "retry";
  //   }
  //   let imgId = imgPath.substr(5, 24);
  //   let jsPath = '/js/manga/' + bookId + "/" + chapterNum + "/" + imgId;
  //   if (zoom !== null) {
  //     jsPath = jsPath + "/" + zoom;
  //   }
  //   jsPath = jsPath + '.js';
  //   return jsPath;
  // },
  // getJsPathBySource(encryptedSource, zoom) {
  //   if (encryptedSource == null) {
  //     throw "retry";
  //   }
  //   let jsPath = '/js/' + encryptedSource;
  //   if (zoom !== null) {
  //     jsPath = jsPath + "/" + zoom;
  //   }
  //   jsPath = jsPath + '.js';
  //   return jsPath;
  // },
};

export default kkUtil;



// WEBPACK FOOTER //
// ./src/assets/js/kk-util.js